import React from "react";

interface DorasIconProps {
    /**
     * Size of the icon in pixels. Can be a number or string with units.
     * @default 24
     */
    size?: number | string;

    /**
     * Color of the icon. Accepts any valid CSS color value.
     * @default "rgb(31,31,31)"
     */
    color?: string;

    /**
     * Additional CSS class names to apply to the SVG element.
     */
    className?: string;

    /**
     * Additional props to pass to the SVG element.
     */
    [key: string]: any;
}

/**
 * DorasIcon - A customizable SVG icon component for the Doras brand
 *
 * This component renders the Doras logo/icon with customizable size and color.
 * The SVG maintains its aspect ratio and scales proportionally.
 */
export const DorasIcon: React.FC<DorasIconProps> = ({
    size = 24,
    color = "rgb(31,31,31)",
    className = "",
    ...props
}) => {
    // Convert size to pixel value if it's a number
    const sizeValue = typeof size === "number" ? `${size}px` : size;

    return (
        <svg
            width={sizeValue}
            height={sizeValue}
            viewBox="0 0 1500 1500"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            xmlSpace="preserve"
            className={className}
            style={{
                fillRule: "evenodd",
                clipRule: "evenodd",
                strokeLinejoin: "round",
                strokeMiterlimit: 2,
            }}
            {...props}
        >
            <path
                d="M574.314,0.002C257.129,0.002 0,257.132 0,574.318L0,779.766L345.832,779.766L345.832,574.318C345.832,448.131 448.127,345.836 574.314,345.836L1154.17,345.836L1154.17,666.67L1154.15,666.67L1154.15,980.131C1154.1,1026.27 1135.76,1070.51 1103.13,1103.14C1070.45,1135.81 1026.14,1154.17 979.926,1154.17L345.832,1154.17L345.832,961.314L0,961.314L0,1301.85C0,1411.25 88.655,1499.94 198.041,1500L980.164,1500C1118.01,1499.94 1250.2,1445.16 1347.68,1347.68C1442.91,1252.44 1497.26,1124.02 1499.76,989.588L1500,989.588L1500,198.16C1500,88.721 1411.28,0.002 1301.85,0.002L574.314,0.002Z"
                fill={color}
            />
        </svg>
    );
};

export default DorasIcon;
